import { patchCommercialInboundApprove, patchResearchInboundApprove, } from "@erp/shared/api/generated/wrappers/inbound";
import { useMutation, useQuery } from "@tanstack/vue-query";
import { computed } from "vue";
import { usePageInfo } from "@erp/shared/composables/usePageInfo";
import { useState } from "@erp/shared/composables/useState";
import { useInvalidateQueries } from "@erp/shared/composables/useInvalidateQueries";
import { queries } from "@erp/shared/queries";
import { showAlert } from "@erp/shared/utils/dialog";
export const useInboundSearchAction = () => {
    const { isCommercialPage } = usePageInfo();
    const { invalidateQueries } = useInvalidateQueries();
    const [readParams, setReadParams] = useState(null);
    const [inboundId, setInboundId] = useState(null);
    const readInboundConfirmQueryOptions = computed(() => {
        return {
            ...queries.inbound.confirm(isCommercialPage.value, readParams.value ?? undefined),
        };
    });
    const readInboundConfirm = useQuery(readInboundConfirmQueryOptions);
    const readInboundProductQueryOptions = computed(() => {
        const inboundIdValue = inboundId.value ?? 0;
        return {
            ...queries.inbound.products(isCommercialPage.value, inboundIdValue),
            enabled: computed(() => !!inboundId.value),
        };
    });
    const readInboundProduct = useQuery(readInboundProductQueryOptions);
    const updateInboundApproval = useMutation({
        mutationFn: async ({ pathParams, body }) => {
            return isCommercialPage.value
                ? await patchCommercialInboundApprove({
                    pathParams,
                    body,
                })
                : await patchResearchInboundApprove({
                    pathParams,
                    body,
                });
        },
        onSuccess: async () => {
            await invalidateQueries([queries.inbound._def, queries.project._def]);
            readInboundConfirm.refetch();
        },
        onError: () => showAlert("입고 승인 처리에 실패했습니다."),
    });
    return {
        readInboundConfirm,
        readInboundProduct,
        readParams,
        updateInboundApproval,
        setInboundId,
        setReadParams,
    };
};
